//export const BASE_URL: string = 'http://localhost:9000/api/';
//export const BASE_URL: string = 'https://flyqazaqgroupapi-training.intelisys.ca/api/';
export const BASE_URL: string = 'https://flyqazaqgroupapi.intelisys.ca/api/';

export const TIME_REFRESH_TOKEN: number = 15000;
export const TIME_REFRESH_FARE_RESULT: number = 30;
